<template>
    <div class="attr_dialog pipeattr" v-if="curFeature">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="属性设置" name="properities">
                <el-table
                    :data="curProperities"
                    border
                    style="width: 100%"
                    class="attr-table"
                    cell-class-name="attr-cell"
                    align="center"
                    max-height="350"
                    @cell-click="handleCellClick"
                    header-row-class-name="attr-header">
                    <el-table-column
                        label='字段名'
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="input-box">
                                <input class="input_inner" type="text" @blur="handleInputBlur" v-model="scope.row.name"/>
                            </div>
                            <span class="input-text">{{scope.row.name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label='字段值'
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="input-box">
                                <input class="input_inner" type="text" @blur="handleInputBlur" v-model="scope.row.prop"/>
                            </div>
                            <span class="input-text">{{scope.row.prop}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" class="operate">
                        <template slot-scope="scope">
                            <el-button
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="btn-array">
                    <el-button type="primary" size="small" @click="addProperities">增加属性</el-button>
                    <el-button type="primary" size="small" @click="saveProperities">保存修改</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="保温设置" name="heat" v-if="curFeature.get('_type')=='line'">

            </el-tab-pane>
        </el-tabs>
       
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name:"pipeattr",
    computed:{
        ...mapState('simulation',[
            'map',
        ]),
        // 当前选中的Feature
        curFeature(){
            return this.$store.state.simulation.curFeatures[0];
        },
        // 当前选中的属性
        curProperities(){
            let properties=[];
            if(this.curFeature){
                let pro=this.curFeature.getProperties();
                let ignores=['geometry','_node_type','lines','first_point','last_point','img','_type']; 
                for(let key in pro){
                    // 去掉编辑geometry属性
                    if(ignores.indexOf(key)>=0){
                        continue;
                    }
                    let temp={
                        name:key,
                        prop:pro[key]
                    };
                    properties.push(temp);
                }
            }
            
            return properties;
        }
    },
    data(){
        return {
            activeName:"properities", // 打开的面板
        }
    },
    methods:{
        //单元格点击后，显示input，并让input 获取焦点
        handleCellClick:function(row, column, cell, event){
            // 显示input，并获取焦点
            cell.classList.add('current-cell');
            let input=cell.querySelector(".input-box input");
            if(input){
                input.focus();
            }
            // 隐藏文字
            let text=cell.querySelector(".input-text");
            if(text){
                text.style.display="none";
            }

        },
        //input框失去焦点事件
        handleInputBlur:function(event){   //当 input 失去焦点 时,input 切换为 span，并且让下方 表格消失（注意，与点击表格事件的执行顺序）
            var _event = event;

            // 去掉选中
            var _inputNode = _event.target;
            // 获取单元格
            var cell=_inputNode.parentNode.parentNode.parentNode;
            if(cell && cell.className.indexOf('current-cell')>=0){
                cell.classList.remove('current-cell');
                // 显示文字
                let text=cell.querySelector(".input-text");
                if(text){
                    text.style.display="block";
                }
            }
        },
        // 添加属性
        addProperities(){
            let len=this.curProperities.length;
            let temp={
                name:"新键字段_"+len,
                prop:"请输入"
            };
            this.curProperities.push(temp);
        },
        // 属性删除
        handleDelete(index){
            this.curProperities.splice(index,1);
        },
        // 保存属性修改
        saveProperities(){
            let featureProperities=this.curFeature.getProperties();
            let proArrayKey=[];
            // 遍历属性
            for(let item of this.curProperities){
                let name=item.name;
                proArrayKey.push(name);
                let prop=item.prop;
                // 设置新的属性
                this.curFeature.set(name,prop);
            }
            // 删除属性
            let proStr=proArrayKey.join(",");
            for(let item in featureProperities){
                // 如果属性不存在，则删除
                if(proStr.indexOf(item)<0){
                    delete featureProperities[item];
                }
            };

            // 弹出提示框，提示保存成功
            this.$message({
                message:"保存成功",
                type:"success",
                duration:2000
            });
            // 关闭对话框
            this.$emit("close");
        },
        // id号判断
        checkId(id){
            let source=this.drawSource;
            let features=source.getFeatures();
            let result=false;
            features.forEach(f=>{
                let _type=f.get("_type");
                // 判断当前图形是不是节点
                if(_type!="line"){
                    let nodeid=f.get("id");
                    if(nodeid==id&&this.curFeature!=f){
                        result=true;
                        return;
                    }
                }
            });
            return result;
        }
    }

}
</script>

<style lang="scss">
.pipeattr{
    overflow: auto;
    padding: 5px;
    padding-top: 0;
    height: 100%;
    max-height: 500px;

    .el-tabs__header{
        margin:0 0 5px;
    }
    .el-tabs__nav-scroll{
        padding-left: 0;
    }

    .btn-array{
        text-align:right;
        margin-top: 10px;

        button{
            span{
                cursor: pointer!important;
            }
        }
        
    }

    .attr-table{
        margin-top: 10px;
        .attr-header{
            th{
                background: rgb(78, 132, 255) none repeat scroll 0% 0%;
                color:#fff;
            }

            div{
                text-align: center;
            }
        }

        .input-box {
            display: none;
            border-radius: 0;
            .input_inner{
                line-height: 30px;
                width: 100%;
                border: 1px solid rgb(35, 240, 247);
                font-size: 14px;
                color: #606266;
                text-align: center;
            }
        }
        .input-text{
            height: 32px;
            line-height: 32px;
            padding: 1px;
        }

        .current-cell .input-box {
            display: block;
        }


        .attr-cell{
            padding:0;
            margin:0;
            text-align: center;

            .cell{
                margin: 0;
                padding:0;
                line-height: initial;

                button{
                    span{
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
</style>